import React from "react";
import { Crosshair } from "lucide-react";
import Layout from "../components/Layout";
import useSeo from "../hooks/useSeo";
import { usePredict } from "../hooks/useApi";

const PredictTarget = () => {
  const { data } = usePredict();
  useSeo(
    "Morning Sunday Teer Predict Target | Shillong Teer Direct House Ending",
    "Morning Sunday Teer predicted target — auto-calculated Direct, House and Ending suggestions from recent Shillong Morning Teer results."
  );

  return (
    <Layout title="Predict Target">
      <div className="max-w-3xl mx-auto px-4 py-6">
        <div className="flex items-center gap-2 mb-1">
          <Crosshair className="w-6 h-6 text-[#5c5148]" />
          <h1 className="text-xl font-bold text-[#1f2a37]">
            Morning Sunday Teer Predicted Target
          </h1>
        </div>
        <p className="text-sm text-gray-500 mb-6">
          Auto-calculated from the frequency of the last 30 recorded results.
          For entertainment and analysis only — not a guaranteed outcome.
        </p>

        {!data ? (
          <p className="text-gray-400">Loading...</p>
        ) : (
          <div className="border-2 border-black rounded-sm overflow-hidden max-w-md mx-auto">
            <div className="bg-[#e6e6e6] text-center py-2 text-lg font-medium border-b-2 border-black">
              SHILLONG · {data.date?.replace(/-/g, "/")}
            </div>
            <div className="grid grid-cols-3 bg-[#7fd0b8] font-semibold text-center border-b-2 border-black">
              <div className="py-2 border-r-2 border-black">Direct</div>
              <div className="py-2 border-r-2 border-black">House</div>
              <div className="py-2">Ending</div>
            </div>
            <div className="grid grid-cols-3 text-center text-lg font-bold">
              <div className="py-3 border-r-2 border-black">
                {data.direct.join(", ")}
              </div>
              <div className="py-3 border-r-2 border-black">{data.house}</div>
              <div className="py-3">{data.ending}</div>
            </div>
          </div>
        )}

        <p className="text-xs text-gray-500 italic mt-6 text-center max-w-md mx-auto">
          These targets are generated from historical frequency patterns. Past
          results do not guarantee future outcomes. Please play responsibly.
        </p>
      </div>
    </Layout>
  );
};

export default PredictTarget;
